<template>
  <div>
    <PageHead title="取暖费报销列表"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">报销职工姓名：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入报销职工姓名："
                v-model="queryForm.fullName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">申请时间：</div>
              <a-range-picker
                @change="dateStringChange"
                v-model="queryForm.applyDate"
                format="YYYY.MM.DD"
              />
              <!-- <a-date-picker
                show-time
                class="w200"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="queryForm.applyDate"
              /> -->
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option
                  v-for="(item, index) in $store.state.app.formStatusList"
                  :key="index"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                allowClear
                v-model="organizationId"
                style="width: 360px"
                multiple
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm" style="margin-bottom: 20px">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>

      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="add()" icon="plus"> 代客下单</a-button>
        <a-button
          @click="handleExport"
          type="primary"
          class="handleExport"
          :loading="exportLoading"
          >导出</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <span slot="disposalstate" slot-scope="text">{{ text }}</span>
        <div slot="type" slot-scope="text">
          <template v-if="text == 1">自助报销</template>
          <template v-if="text == 2">在职下单</template>
          <template v-if="text == 3">代客下单</template>
        </div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div :class="'dot' + text + ' mr5'"></div>
          <span
            v-for="(item, index) in $store.state.app.formStatusList"
            :key="index"
          >
            <span v-if="text == item['value']">{{ item.label }}</span>
          </span>
          <span></span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record, 1)">
            查看
          </a-button>

          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="add(record)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button> </template
          ><a-divider
            type="vertical"
            v-if="record.recallButton && record.state == 0"
          />
          <!-- <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button> -->
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '报销单号',
    dataIndex: 'numberNo',
    key: 'numberNo',
    align: 'center'
  },

  {
    title: '报销职工姓名：',
    dataIndex: 'fullName',
    key: 'fullName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '申请时间',
    dataIndex: 'applyTime',
    key: 'applyTime',
    ellipsis: true
  },
  {
    title: '发票数',
    dataIndex: 'enableNum',
    key: 'enableNum',
    ellipsis: true
  },
  {
    title: '票证金额（元）',
    dataIndex: 'verificationFee',
    key: 'verificationFee',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '补贴金额（元）',
    dataIndex: 'verificationFinalFee',
    key: 'verificationFinalFee',
    ellipsis: true,
    align: 'left'
  },

  {
    title: '订单类型',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true,
    align: 'left'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 180,
    align: 'left'
  }
]
import {
  getWarmReimbursementList,
  warmOneselfReimbursementExport,
  warmOneselfReimbursementDelete
} from './api/api'

import { recallProcessFn } from '@/utils/utils'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      expand: false,
      queryForm: {},
      data: [],
      columns,
      page: 1,
      total: 0,
      size: 10,
      loading: false,
      exportLoading: false,
      organizationId: []
    }
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  watch: {
    organizationId: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.queryForm.organizationId = val.join(',')
        } else {
          this.queryForm.organizationId = ''
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getorganizeListFn()
    this.getList()
  },
  methods: {
    ...mapActions(['getorganizeListFn']),
    // 导出
    handleExport() {
      let params = this.queryForm
      this.exportLoading = true
      warmOneselfReimbursementExport(params).then((response) => {
        this.exportLoading = false
        this.$message.success('导出成功')
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '取暖费报销.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'd-fixe-dasset')
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.getList()
        })
        .catch((error) => {
          console.log(error)
          this.getList()
        })
    },
    cancel() {
      //取消
      this.queryForm = {}
      this.organizationId = []
    },
    subMit() {
      this.page = 1
      this.getList()
    },
    dateStringChange(date, dateString) {
      this.queryForm.applyDate = dateString
    },
    // 拉取列表
    getList() {
      let params = {
        fullName: this.queryForm.fullName,
        startTime: this.queryForm.applyDate ? this.queryForm.applyDate[0] : '',
        endTime: this.queryForm.applyDate ? this.queryForm.applyDate[1] : '',
        state: this.queryForm.state,
        organizationId: this.queryForm.organizationId,
        page: this.page,
        size: this.size
      }
      this.loading = true
      getWarmReimbursementList(params).then((res) => {
        if (res.data.code == 0) {
          this.loading = false
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          warmOneselfReimbursementDelete({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.getList()
            }
          })
        }
      })
    },
    add(record) {
      if (record) {
        this.$router.push({
          path:
            '/HeatingFeeDetail?operateType=eidt&id=' +
            record.id +
            '&type=' +
            record.type
        })
      } else {
        this.$router.push('/HeatingFeeDetail?type=3&operateType=add')
      }
    },
    goDetial(record) {
      this.$router.push(
        '/HeatingFeeDetail?id=' +
          record.id +
          '&type=' +
          record.type +
          '&operateType=check' +
          '&isEdit=1'
      )
    },
    pageChange(pageber) {
      this.page = pageber
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        margin-bottom: 20px;
        .query-view-lable {
          width: 110px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/HeatingFee/index.vue